module.exports = __webpack_public_path__ + "img/rtdt.d2e4c171.png";